import React, { Component, createRef } from "react";
import {
  mode,
  GET,
  POST,
  loading,
  alert,
  isLoggedIn,
  setDarkMode,
  twofa,
  profile,
  linkRole,
  setCsrfToken,
  consumeSessionExpiredNotice
} from "../components/CustomComponent.js";
import Turnstile from "react-turnstile";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      password_view: "password",
      remember: false,
      token: "",
      captchaKey: Date.now(),
    };
    this.turnstileRef = createRef();
  }
  async componentDidMount() {
    if (isLoggedIn && twofa) {
      const result = await GET("v1/admin/users/profile");
      if (result?.status) {
        window.location.href = `/${linkRole(profile?.user_type)}/dashboard`;
      }
    } else if (isLoggedIn && !twofa) {
      window.location.href = "/verify-2fa";
    }
    if (mode === "dark") {
      setDarkMode();
    }
    loading(false);
    // ถูกเด้งมาจากหน้าอื่นเพราะ session หมด (expireSession) → บอกเหตุผลที่นี่ กดปิดแล้วอยู่หน้า login ต่อ
    const expired = consumeSessionExpiredNotice();
    if (expired) {
      alert("", "warning", "Session expired", `${expired}. Please login again.`);
    }
  }
  async componentDidUpdate() {
    if (mode === "dark") {
      setDarkMode();
    }
  }

  Login = async () => {
    const { token, email, password, remember } = this.state;
    if (!token) {
      alert("", "warning", "Warning", "Please confirm CAPTCHA.");
      return;
    }
    loading(true);
    let result = await POST("v1/public/login", {
      email: email,
      password: btoa(password),
      remember: remember,
      token: token,
    });
    if (result?.status) {
      // การ์ด #31: backend ตั้ง token เป็น httpOnly cookie มาพร้อม response นี้แล้ว (JS อ่านไม่ได้)
      // ห้ามเก็บ token ใน localStorage อีก และห้ามให้หลุดติดไปกับ scp-profile ผ่าน ...result.data
      const { token, token_expires, csrf_token, ...profileData } = result.data;
      // csrf token มาคู่กับคุกกี้ที่ backend ตั้งให้ ต้องเก็บไว้เพราะเว็บกับ API คนละโดเมน อ่านจากคุกกี้ไม่ได้
      setCsrfToken(csrf_token);
      // login ใหม่ = ไม่ได้สวมสิทธิ์ใคร ล้างข้อมูล impersonation รอบก่อนที่อาจค้าง (backend ล้างคุกกี้คู่กันแล้ว)
      localStorage.removeItem("scp-original-profile");
      localStorage.removeItem("scp-original-2fa");
      localStorage.setItem(
        "scp-profile",
        JSON.stringify({
          ...profileData,
          password: "",
          verify_time: new Date(
            new Date().setMinutes(new Date().getMinutes() + 10)
          ).getTime(),
        })
      );
      if (result.data.is_2fa) {
        window.location.href = `/verify-2fa`;
      } else {
        localStorage.setItem(
          "scp-2fa",
          btoa(
            result.data?.uid +
              ":" +
              new Date(new Date().setDate(new Date().getDate() + 7)).getTime()
          )
        );
        window.location.href = `/${
          linkRole(result.data?.user_type)
        }/dashboard`;
      }
    } else {
      this.setState({ token: "", captchaKey: Date.now() });
      if (
        result.message === "User not verified, please verify your account first"
      ) {
        alert(
          "/resend-verification?email=" + email,
          "warning",
          "Warning",
          "User not verified, please verify your account first",
          "verify",
          "cancel"
        );
      }
    }
    loading(false);
  };

  render() {
    const { email, password, password_view, token } =
      this.state;
    return !isLoggedIn ? (
      <div className="w-100 min-vh-100 background position-relative auth-scope">
        <div className="row w-100 mx-0">
          <div
            className={`col-12 d-flex align-items-center justify-content-center d-md-none auth-brand py-3`}
          >
            <img
              alt="logo"
              src={LOGO}
              className="w-75"
              style={{ minWidth: 350 }}
              fetchpriority="high"
            />
          </div>
          <div
            className={`col-6 d-none d-md-flex align-items-center justify-content-center auth-brand min-vh-100`}
          >
            <img
              alt="logo"
              src={LOGO}
              style={{ width: "60%", minWidth: 400 }}
            />
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <div className="col-11 col-md-10 col-lg-8 col-xl-7 mx-auto my-5 auth-card">
              <h3 className="fw-bold text-dark mb-3">Signin</h3>
              <div className="mb-3">
                <small>
                  Please enter your email and password to access the system.
                </small>
              </div>
              <label className="mb-1">Username</label>
              <input
                className="form-control mb-3"
                type="text"
                placeholder="Username"
                data-testid="input-login-email"
                onChange={(e) => {
                  this.setState({ email: e.target.value });
                }}
                value={email}
              />
              <label className="mb-1">Password</label>
              <div className="position-relative">
                <input
                  className="form-control mb-3"
                  type={password_view}
                  placeholder="Password"
                  data-testid="input-login-password"
                  onChange={(e) => {
                    this.setState({ password: e.target.value });
                  }}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      this.Login();
                    }
                  }}
                  value={password}
                />
                <div
                  className="wpx-40 hpx-40 d-flex justify-content-center align-items-center icon pointer position-absolute"
                  style={{ right: 0, top: 0 }}
                  onClick={() => {
                    this.setState({
                      password_view:
                        password_view === "password" ? "text" : "password",
                    });
                  }}
                >
                  {password_view === "password" ? "\uf06e" : "\uf070"}
                </div>
              </div>
              <div className="w-100 mb-2">
                <Turnstile
                  key={this.state.captchaKey}
                  size="flexible"
                  sitekey={process.env.REACT_APP_CLOUDFLARE_SITE_KEY}
                  onVerify={(token) => {
                    this.setState({ token });
                  }}
                  onExpire={() => {
                    this.setState({ token: "" });
                  }}
                />
              </div>
              <button
                type="button"
                className={`btn ${
                  token ? "btn-dark" : "btn-secondary"
                } w-100 mb-3`}
                data-testid="btn-login-submit"
                onClick={() => {
                  this.Login();
                }}
                disabled={!token}
              >
                Login
              </button>
              <div className="w-100 text-center mb-4">
                <small>
                  Forgotten your password?
                  <a
              href="/reset-password"
              className="text-decoration-none text-secondary text-14 mx-2"
            >
              Reset password
            </a>
                </small>
              </div>
              <div className="w-100 text-center mb-5">
                <small className="text-secondary text-center">
                  Copyright © 2025 SwiftGoldPay version{" "}
                  {global.version}
                </small>
              </div>
            </div>
          </div>
        </div>
        <div
          className="position-absolute d-flex flex-wrap px-3"
          style={{ right: 8, bottom: 8 }}
        >
          <span
            className="pointer mx-2"
            onClick={() => {
              localStorage.setItem("mode", mode === "light" ? "dark" : "light");
              window.location.reload();
            }}
          >
            <span className="icon me-1">
              {mode === "dark" ? "\uf186" : "\uf185"}
            </span>
            {mode === "dark" ? "Dark Mode" : "Light Mode"}
          </span>
          <div className="d-flex flex-wrap">
            {/* <a
              href="/resend-verification"
              className="text-decoration-none text-secondary text-14 mx-2"
            >
              Resend Verification
            </a> */}
            <a
              href="/document-api"
              className="text-decoration-none text-secondary text-14 mx-2"
            >
              API & Documents
            </a>
            <a
              href="/policy-privacy"
              className="text-decoration-none text-secondary text-14 mx-2"
            >
              Policy & Privacy
            </a>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }
}
